import { VideoTabs } from '@/components/features/video'
import { AnimatedOutlet } from '@/components/ui'

export function VideoPage() {
  return (
    <div>
      {/* Tab Navigation */}
      <div className="px-6 md:px-8 pt-6">
        <VideoTabs />
      </div>

      {/* Tab Content with transition */}
      <AnimatedOutlet />
    </div>
  )
}
